<template>
  <!-- eslint-disable -->
  <div>
    <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <prestamo-filters ref="filters" />
      <b-card no-body class="mb-0">
        <b-table
          class="position-relative"
          :hover="true"
          :items="records"
          responsive
          :fields="fields"
          show-empty
          empty-text="No existen"
          @sort-changed="sortChanged"
        >

        <template #cell(created_at)="data">
          <span>{{ formatDateTime(data.item.created_at) }}</span>
        </template>

        <template #cell(limitDate)="data">
          <span>{{ formatDateTime(data.item.limitDate) }}</span>
        </template>

        <template #cell(billNumber)="data">
          <span>
            {{
              data.item.loanRecords.length > 0 &&
              data.item.loanRecords[data.item.loanRecords.length - 1].loan &&
              data.item.loanRecords[data.item.loanRecords.length - 1].loan.billNumber
                ? data.item.loanRecords[data.item.loanRecords.length - 1].loan.billNumber
                : 'No tiene factura aún'
            }}
          </span>
        </template>

        <template #cell(state)="data">
          <span
            :class="{
              'badge badge-success': data.item.state === 'Completo',
              'badge badge-danger': data.item.state === 'Incompleto',
              'badge badge-warning' : data.item.state === 'Pendiente'
            }"
            style="padding: 5px 10px; font-size: 12px;"
          >
            {{ data.item.state }}
          </span>
        </template>

        <template #cell(actions)="data">
            <b-button size="sm" @click="detail(data.item)" v-b-tooltip.hover.top="'Detalle'" variant="flat-info">
              <feather-icon icon="BoxIcon" />
            </b-button>
        </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col sm="3">
              <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="input-md">
                <b-form-select
                  v-model="showEntrie"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="entries"
                  @change="changeSizePage"
                />
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mt-75" style="font-size: 12px">
              <span> {{ totalElements }} Registros en total</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalElements"
                :per-page="showEntrie"
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @change="cambioPagina"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script> 
import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import prestamoFilters from './prestamoFilters.vue'
import LoanService from '@/services/LoanService';

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  data() {
    return{
        showLoading: false,
        records: [],
        fields: [
          { key: 'billNumber', label: 'Documento', sortable: false },
          { key: 'client.fullname', label: 'Cliente', sortable: false },
          { key: 'created_at', label: 'F. Solicitud', sortable: false},
          { key: 'limitDate', label: 'F. Limite', sortable: false},
          { key: 'establishmentOrigin.name', label: 'Establecimiento Origen', sortable: false },
          { key: 'state', label: 'Estado', sortable: false},
          { key: 'actions', label: 'Acciones', sortable: false},
        ],
        arrayFilters: [],
        currentPage: 1,
        entries: [10, 20, 50, 100],
        showEntrie: 10,
        totalElements: 0,
        id: 0,
        sort: 'id',
        order: 'desc',
    }
  },
  components:{
    prestamoFilters
  },
  mounted(){
    this.getData()
  },
  methods: {
    cambioPagina(e) {
      this.currentPage = e
    },
    changeSizePage() {
      this.getData()
    },
    sortChanged(data) {
      this.sort = data.sortBy
      if (data.sortDesc) {
        this.order = 'desc'
      } else this.order = 'asc'
    },

    async getData(){
      this.records = []
      this.totalElements = 0
      this.showLoading = true
      const url = `?limit=${this.showEntrie}&page=${this.currentPage}&order=${this.order}&sort=${this.sort}&filter=${JSON.stringify(this.arrayFilters)}`;
      const resp = await LoanService.getLoans(url, this.$store)
      if (resp.data.rows.length != 0) {
        this.records = resp.data.rows
        this.totalElements = resp.data.rows.length
      }
      
       this.totalElements = this.records.length;
      this.showLoading = false;
    },

    formatDateTime(date) {
        if (!date) return "Sin fecha"; 
        const d = new Date(date);
        const year = d.getUTCFullYear();
        const month = String(d.getUTCMonth() + 1).padStart(2, "0"); 
        const day = String(d.getUTCDate()).padStart(2, "0"); 
        const hours = String(d.getUTCHours()).padStart(2, "0");
        const minutes = String(d.getUTCMinutes()).padStart(2, "0"); 
        return `${year}-${month}-${day} - ${hours}:${minutes}`;
    },

    detail(item){
      this.$router.push('/prestamo/detail/' + item.id)
    },


  },
}


</script>